import React from 'react';
import { format } from 'date-fns';
import { useNavigate } from 'react-router-dom';
import { AppointmentTimeIcon } from './icons/OverviewCardIcons';
import OverviewBoardHeader from './board/OverviewBoardHeader';
import './styles/TodayAppointmentsCard.css';
import './board/OverviewBoard.css';

const getStatusClass = (status) => {
  const normalized = (status || 'pending').toLowerCase().trim();
  if (normalized === 'cancelled' || normalized === 'canceled') return 'cancelled';
  if (normalized === 'confirmed') return 'confirmed';
  if (normalized === 'completed') return 'confirmed';
  return 'pending';
};

const getStatusLabel = (status) => {
  const normalized = (status || 'pending').toLowerCase().trim();
  if (normalized === 'cancelled' || normalized === 'canceled') return 'cancelled';
  if (normalized === 'confirmed') return 'confirmed';
  if (normalized === 'completed') return 'completed';
  return 'pending';
};

const TodayMeetingsCard = ({ todayMeetings, onViewAll, onMeetingClick }) => {
  const navigate = useNavigate();

  const handleViewAll = () => {
    navigate('/app/overview/meetings/list', { state: { initialTab: 1 } });
  };

  return (
    <div className="today-appointments-container overview-board">
      <OverviewBoardHeader
        eyebrow="Today"
        title="Meetings"
        count={`${todayMeetings.length} scheduled`}
        actionLabel="View"
        onAction={handleViewAll}
        actionTitle="View all today's meetings"
      />

      <div className="today-appointments-content">
        {todayMeetings.length > 0 ? (
          <ul className="today-appointments-list">
            {todayMeetings.slice(0, 4).map((meeting, index) => (
              <li
                key={meeting.id || index}
                className="today-appointments-item"
                onClick={() => onMeetingClick && onMeetingClick(meeting)}
              >
                <div className="today-appointment-content">
                  <div className="appointment-row">
                    <div className="appointment-left">
                      <h4 className="appointment-client-name">
                        {meeting.title || 'Meeting'}
                      </h4>
                      <div className="today-appointment-details">
                        <p className="today-appointment-service">
                          {meeting.clientName ? `With ${meeting.clientName}` : 'Meeting'}
                        </p>
                        <div className="today-appointment-time">
                          <AppointmentTimeIcon />
                          {format(meeting.dateTime instanceof Date ? meeting.dateTime : new Date(meeting.dateTime), 'PP p')}
                        </div>
                      </div>
                    </div>
                    <span className={`appointment-status ${getStatusClass(meeting.status)}`}>
                      {getStatusLabel(meeting.status)}
                    </span>
                  </div>
                </div>
              </li>
            ))}
          </ul>
        ) : (
          <div className="today-appointments-empty">
            <p>No meetings scheduled for today</p>
          </div>
        )}
      </div>

      {todayMeetings.length > 4 && (
        <div className="today-appointments-footer">
          <p onClick={handleViewAll}>
            {todayMeetings.length - 4} more meetings today
          </p>
        </div>
      )}
    </div>
  );
};

export default TodayMeetingsCard;
